/**
 * Porta das telas do Portal Kit: só administrador, e só quem tem a feature no
 * plano. Quem barra de verdade é a API (403); aqui se evita mostrar uma tela
 * que só ia devolver erro.
 */
import type { ReactNode } from 'react';

import { useFeatureEstado } from '@/hooks/useFeature';
import { useAuth } from '@/store/useAuth';

import styles from './Portal.module.css';

export function PortalGate({ children }: { children: ReactNode }) {
  const role = useAuth((s) => s.role);
  const { habilitada, carregando } = useFeatureEstado('portal_kit');

  if (role !== 'admin') {
    return (
      <div className={styles.aviso} role="alert">
        <span className={styles.avisoTitulo}>Só para administradores</span>
        <span>
          A configuração do Portal Kit muda o que os sites publicam. Peça a um administrador.
        </span>
      </div>
    );
  }
  if (carregando) return <p className={styles.mudo}>Carregando…</p>;
  if (!habilitada) {
    return (
      <div className={styles.avisoWarn} role="alert">
        <span className={styles.avisoTitulo}>Portal Kit não incluído no plano</span>
        <span>
          Este plano não tem o WIREDESK Portal Kit. Fale com o administrador da plataforma para
          habilitar.
        </span>
      </div>
    );
  }
  return <>{children}</>;
}
